import { useCallback } from 'react'

import { useMutation } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { Toast } from 'ui/components/Toast'

import { handlerServerError } from '@orbit/errors'

export const useDetachContactAndCompany = (onSuccess: () => void) => {
  const { mutateAsync: saveContact } = useMutation<void, Error, { companyId: number; contactId: number }>({
    mutationFn: (opts) => Request.delete(Request.urls.bank.contactCompanyConnection, opts),
    onSuccess: async () => {
      onSuccess()
      Toast.successSmall('Contact and company were detached.')
    },
    onError: (error) => handlerServerError(error)
  })

  const detachContactAndCompany = useCallback(
    async (companyId: number, contactId: number) => saveContact({ companyId, contactId }),
    [saveContact]
  )

  return {
    detachContactAndCompany
  }
}
